(() => {
  const config = window.loyaltyConfig || {};
  const api = window.RewardsAPI;
  const formatNumber = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL');

  const ensureCardEffectRuntime = () => {
    if (!config.isAuthenticated || document.querySelector('link[data-ytcg-card-effects]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet'; link.dataset.ytcgCardEffects = 'true';
    link.href = `${String(config.apiUrl || '').replace(/\/$/, '')}/card-effects.css?v=2026-10-12-2`;
    document.head.appendChild(link);
  };
  ensureCardEffectRuntime();

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const setText = (root, selector, value) => {
    const node = root.querySelector(selector);
    if (node) node.textContent = value;
  };

  const remainingLabel = (milliseconds) => {
    const total = Math.max(0, Math.floor(milliseconds / 1000));
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return `${days ? `${days}d ` : ''}${String(hours).padStart(2, '0')}u ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
  };

  const startQuestTimers = (container, serverTime) => {
    if (container._questTimer) window.clearInterval(container._questTimer);
    const clockDifference = Date.parse(serverTime) - Date.now();
    const update = () => {
      container.querySelectorAll('[data-quest-deadline]').forEach((timer) => {
        const remaining = Date.parse(timer.dataset.questDeadline) - (Date.now() + clockDifference);
        timer.textContent = remaining <= 0
          ? 'Nieuwe periode gestart · pagina wordt bijgewerkt'
          : `${timer.dataset.completed === 'true' ? 'Nieuwe quest over' : 'Nog beschikbaar'}: ${remainingLabel(remaining)}`;
      });
    };
    update();
    container._questTimer = window.setInterval(update, 1000);
  };

  const renderQuests = (container, quests, serverTime) => {
    if (!container) return;
    container.replaceChildren(...quests.map((quest) => {
      const card = el('article', 'loyalty-card quest-card');
      const heading = el('div', 'quest-card__heading');
      heading.append(el('span', 'loyalty-kicker', quest.type), el('strong', '', quest.name));
      const reward = el('span', 'points-chip', `+${quest.reward}`);
      heading.appendChild(reward);
      const progress = el('div', 'loyalty-progress');
      progress.setAttribute('aria-label', `${quest.progress} van ${quest.goal}`);
      const bar = el('span');
      bar.style.width = `${Math.min(100, (quest.progress / quest.goal) * 100)}%`;
      progress.appendChild(bar);
      const footer = el('div', 'quest-card__footer');
      footer.append(el('small', 'loyalty-muted', `${quest.progress} / ${quest.goal}`));
      const deadline = quest.endsAt && (!quest.resetsAt || Date.parse(quest.endsAt) < Date.parse(quest.resetsAt)) ? quest.endsAt : quest.resetsAt;
      if (deadline) {
        const timer = el('small', 'quest-timer');
        timer.dataset.questDeadline = deadline;
        timer.dataset.completed = String(Boolean(quest.completed));
        timer.setAttribute('role', 'timer');
        footer.appendChild(timer);
      } else {
        footer.append(el('small', 'quest-timer', 'Doorlopende quest'));
      }
      card.append(heading, progress, footer);
      return card;
    }));
    startQuestTimers(container, serverTime);
  };

  const renderAchievements = (container, historyContainer, historyDetails, historyCount, achievements) => {
    if (!container) return;
    const historyWasOpen = Boolean(historyDetails?.open);
    const renderItems = (items) => items.map((achievement) => {
      const card = el('article', `achievement-card${achievement.unlocked ? ' is-unlocked' : ''}`);
      card.append(el('span', 'achievement-card__icon', achievement.icon), el('strong', '', achievement.name), el('small', 'loyalty-muted', achievement.description));
      return card;
    });
    const visibleAchievements = achievements.slice(0, 5);
    const olderAchievements = achievements.slice(5);
    container.replaceChildren(...renderItems(visibleAchievements));
    if (historyDetails && historyContainer) {
      historyDetails.hidden = olderAchievements.length === 0;
      historyDetails.open = olderAchievements.length > 0 && historyWasOpen;
      historyContainer.replaceChildren(...renderItems(olderAchievements));
    }
    if (historyCount) historyCount.textContent = String(olderAchievements.length);
  };

  const renderGames = (container, games) => {
    if (!container) return;
    container.replaceChildren(...games.map((game) => {
      const card = el('article', `arcade-game-card${game.featured ? ' is-featured' : ''}`);
      const art = el('div', 'arcade-game-card__art');
      art.append(el('span', '', game.id === 'collection-clash' ? 'CLASH' : game.id === 'pack-sort' ? 'SORT' : '?'));
      const body = el('div', 'arcade-game-card__body');
      body.append(el('span', 'loyalty-kicker', game.category), el('h3', '', game.name), el('p', '', game.description));
      const meta = el('div', 'arcade-game-card__meta');
      meta.append(el('span', '', `◷ ${game.playTime}`), el('span', '', game.reward));
      body.appendChild(meta);
      if (config.isAuthenticated && Number(game.dailyLimit) > 0) body.appendChild(el('small', 'loyalty-muted', `Rewarded plays: ${game.attemptsUsed} / ${game.dailyLimit}`));
      const action = game.comingSoon ? el('span', 'button button--secondary button--full', 'Binnenkort') : el('a', 'button button--full', 'Speel nu');
      if (!game.comingSoon) action.href = game.href;
      body.appendChild(action);
      card.append(art, body);
      return card;
    }));
  };

  const renderRewards = (container, rewards, wallet, refreshOverview) => {
    if (!container) return;
    if (!rewards.length) {
      const empty = el('div', 'loyalty-empty', 'Er zijn momenteel geen rewards beschikbaar.');
      empty.style.cssText = 'text-align:left;padding:4px 0';
      container.style.display = 'block';
      container.replaceChildren(empty);
      return;
    }
    container.style.removeProperty('display');
    container.replaceChildren(...rewards.map((reward) => {
      const card = el('article', 'reward-card loyalty-card');
      const media = el('div', 'reward-card__media');
      const placeholder = () => media.appendChild(el('span', 'reward-card__placeholder', reward.physical ? '◇' : '€'));
      if (reward.imageUrl) {
        const image = document.createElement('img');
        image.src = reward.imageUrl;
        image.alt = reward.imageAlt || reward.name;
        image.loading = 'lazy';
        image.addEventListener('error', () => { media.replaceChildren(); placeholder(); }, { once: true });
        media.appendChild(image);
      } else {
        placeholder();
      }
      media.appendChild(el('span', 'reward-card__type', reward.physical ? 'Fysieke reward' : 'Digitale reward'));
      const body = el('div', 'reward-card__body');
      body.append(el('h3', '', reward.name), el('strong', 'reward-card__cost', `${formatNumber.format(reward.cost)} ${config.currencyName}`));
      if (reward.description) body.appendChild(el('p', 'reward-card__description', reward.description));
      if (reward.physical) {
        const stock = reward.availableQuantity === null || reward.availableQuantity === undefined
          ? 'Onbeperkt beschikbaar'
          : reward.availableQuantity > 0
            ? `Nog ${formatNumber.format(reward.availableQuantity)} beschikbaar`
            : 'Uitverkocht';
        body.append(el('small', `reward-card__stock${reward.availableQuantity === 0 ? ' is-empty' : ''}`, stock));
      }
      const button = el('button', 'button button--small', reward.available ? 'Claim reward' : 'Uitverkocht');
      button.type = 'button';
      button.disabled = !config.isAuthenticated || wallet.balance < reward.cost || !reward.available;
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          const result = await api.claimReward(reward.id);
          document.dispatchEvent(new CustomEvent('loyalty:balance', { detail: result.newBalance }));
          button.textContent = result.mock ? 'Demo geclaimd' : 'Geclaimd';
          if (refreshOverview) await refreshOverview();
        } catch (error) {
          button.disabled = false;
          window.alert(error.message);
        }
      });
      body.appendChild(button);
      card.append(media, body);
      return card;
    }));
  };

  const startGiveawayTimers = (section, serverTime, refreshOverview) => {
    if (section._giveawayTimer) window.clearInterval(section._giveawayTimer);
    section._giveawayRefreshPending = false;
    const clockDifference = Date.parse(serverTime) - Date.now();
    const update = () => {
      let boundaryReached = false;
      section.querySelectorAll('[data-giveaway-deadline]').forEach((timer) => {
        const remaining = Date.parse(timer.dataset.giveawayDeadline) - (Date.now() + clockDifference);
        timer.textContent = remaining <= 0 ? 'Wordt bijgewerkt…' : remainingLabel(remaining);
        if (remaining <= 0) boundaryReached = true;
      });
      if (boundaryReached && !section._giveawayRefreshPending) {
        section._giveawayRefreshPending = true;
        window.clearInterval(section._giveawayTimer);
        window.setTimeout(() => refreshOverview?.(), 750);
      }
    };
    update();
    section._giveawayTimer = window.setInterval(update, 1000);
  };

  const renderGiveaways = (section, container, historyContainer, historyDetails, historyCount, giveaways, wallet, serverTime, refreshOverview) => {
    if (!section || !container) return;
    const historyWasOpen = Boolean(historyDetails?.open);
    const historyStatuses = new Set(['DRAWN', 'CANCELLED']);
    const activeGiveaways = (giveaways || [])
      .filter((giveaway) => !historyStatuses.has(giveaway.status))
      .sort((left, right) => Date.parse(left.endsAt) - Date.parse(right.endsAt));
    const historicalGiveaways = (giveaways || [])
      .filter((giveaway) => historyStatuses.has(giveaway.status))
      .sort((left, right) => Date.parse(right.endsAt) - Date.parse(left.endsAt));
    if (!activeGiveaways.length && !historicalGiveaways.length) {
      section.hidden = true;
      container.replaceChildren();
      return;
    }
    section.hidden = false;
    const dateTime = new Intl.DateTimeFormat(document.documentElement.lang || 'nl-NL', { dateStyle: 'medium', timeStyle: 'short' });
    const statusLabels = { ACTIVE: 'Je doet mee', WINNER: 'Gewonnen · prijs staat in je Vault', NOT_SELECTED: 'Trekking afgerond', CANCELLED: 'Geannuleerd' };
    const serverNow = Date.parse(serverTime);
    const renderCards = (items, historical = false) => items.map((giveaway) => {
      const card = el('article', `giveaway-card loyalty-card${historical ? ' is-history' : ''}`);
      const media = el('div', 'giveaway-card__media');
      const placeholder = () => media.appendChild(el('span', 'giveaway-card__placeholder', '◇'));
      if (giveaway.imageUrl) {
        const image = document.createElement('img');
        image.src = giveaway.imageUrl;
        image.alt = giveaway.imageAlt || giveaway.prize;
        image.loading = 'lazy';
        image.addEventListener('error', () => { media.replaceChildren(); placeholder(); }, { once: true });
        media.appendChild(image);
      } else {
        placeholder();
      }
      media.appendChild(el('span', 'giveaway-card__prize-badge', giveaway.physical ? 'Fysieke prijs' : 'Digitale prijs'));

      const body = el('div', 'giveaway-card__body');
      const header = el('div', 'giveaway-card__header');
      const title = el('div');
      const kicker = giveaway.status === 'DRAWN' ? 'Trekking afgerond' : giveaway.status === 'CANCELLED' ? 'Geannuleerd' : 'Nu beschikbaar';
      title.append(el('span', 'loyalty-kicker', kicker), el('h3', '', giveaway.name));
      header.appendChild(title);
      body.append(header, el('strong', 'giveaway-card__prize', giveaway.prize));
      if (giveaway.description) body.appendChild(el('p', 'giveaway-card__description', giveaway.description));

      const requirements = el('ul', 'giveaway-card__requirements');
      (giveaway.requirements?.length ? giveaway.requirements : ['Geen extra actie vereist']).forEach((requirement) => requirements.appendChild(el('li', '', requirement)));
      body.appendChild(requirements);
      if (giveaway.physical) {
        const minimum = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(giveaway.minimumOrderCents || 0) / 100);
        body.appendChild(el('small', 'giveaway-card__delivery', `De prijs komt in je Reward Vault en gaat mee met een bestelling vanaf ${minimum}.`));
      }

      const meta = el('div', 'giveaway-card__meta');
      meta.append(el('span', '', `👥 ${formatNumber.format(giveaway.participantCount)} deelnemer(s)`), el('span', '', `Minimum ${formatNumber.format(giveaway.minimumParticipants)}`));
      body.appendChild(meta);

      if (!historical && giveaway.status === 'OPEN') {
        const notStarted = serverNow < Date.parse(giveaway.startsAt);
        const countdown = el('div', 'giveaway-card__countdown');
        countdown.appendChild(el('span', '', notStarted ? 'Opent over' : 'Sluit over'));
        const timer = el('strong');
        timer.dataset.giveawayDeadline = notStarted ? giveaway.startsAt : giveaway.endsAt;
        timer.setAttribute('role', 'timer');
        countdown.appendChild(timer);
        body.appendChild(countdown);
      } else {
        body.appendChild(el('small', 'giveaway-card__date', `${giveaway.status === 'DRAWN' ? 'Gesloten' : 'Einddatum'}: ${dateTime.format(new Date(giveaway.endsAt))}`));
      }

      if (giveaway.entryStatus) {
        body.appendChild(el('strong', `giveaway-card__status is-${String(giveaway.entryStatus).toLowerCase()}`, statusLabels[giveaway.entryStatus] || giveaway.entryStatus));
      } else if (giveaway.canEnter) {
        const actions = el('div', 'giveaway-card__actions');
        let instagram = null;
        if (giveaway.instagramRequired) {
          const label = el('label', 'giveaway-confirm');
          instagram = document.createElement('input');
          instagram.type = 'checkbox';
          label.append(instagram, document.createTextNode(' Ik bevestig dat ik Your TCG Store op Instagram volg'));
          actions.appendChild(label);
        }
        const button = el('button', 'button', giveaway.pointsCost > 0 ? `Doe mee voor ${formatNumber.format(giveaway.pointsCost)} punten` : 'Doe gratis mee');
        button.type = 'button';
        button.disabled = wallet.balance < giveaway.pointsCost;
        button.addEventListener('click', async () => {
          if (instagram && !instagram.checked) { window.alert('Bevestig eerst dat je ons op Instagram volgt.'); return; }
          if (!window.confirm(`Je registreert één deelname${giveaway.pointsCost > 0 ? ` en levert ${giveaway.pointsCost} punten in` : ''}. Doorgaan?`)) return;
          button.disabled = true;
          try {
            const result = await api.enterGiveaway(giveaway.id, Boolean(instagram?.checked));
            document.dispatchEvent(new CustomEvent('loyalty:balance', { detail: result.newBalance }));
            await refreshOverview?.();
          } catch (error) {
            button.disabled = false;
            window.alert(error.message);
          }
        });
        actions.appendChild(button);
        body.appendChild(actions);
      } else if (!historical) {
        body.appendChild(el('strong', 'giveaway-card__status', giveaway.status === 'CLOSED' ? 'De deelname is gesloten · trekking volgt' : 'De deelname is nog niet geopend'));
      }
      card.append(media, body);
      return card;
    });

    container.replaceChildren(...renderCards(activeGiveaways));
    if (historyDetails && historyContainer) {
      historyDetails.hidden = historicalGiveaways.length === 0;
      historyDetails.open = historicalGiveaways.length > 0 && historyWasOpen;
      historyContainer.replaceChildren(...renderCards(historicalGiveaways, true));
    }
    if (historyCount) historyCount.textContent = String(historicalGiveaways.length);
    startGiveawayTimers(section, serverTime, refreshOverview);
  };

  const startVaultTimers = (container, serverTime, refreshOverview) => {
    if (container._vaultTimer) window.clearInterval(container._vaultTimer);
    const clockDifference = Date.parse(serverTime) - Date.now();
    const update = () => {
      let expired = false;
      container.querySelectorAll('[data-vault-deadline]').forEach((timer) => {
        const remaining = Date.parse(timer.dataset.vaultDeadline) - (Date.now() + clockDifference);
        timer.textContent = remaining <= 0 ? 'Wordt nu vrijgegeven · punten worden teruggestort' : `Verloopt over: ${remainingLabel(remaining)}`;
        if (remaining <= 0) expired = true;
      });
      if (expired && !container._vaultRefreshPending) {
        container._vaultRefreshPending = true;
        window.setTimeout(() => refreshOverview?.(), 1500);
      }
    };
    update();
    container._vaultTimer = window.setInterval(update, 1000);
  };

  const renderVault = (container, historyContainer, historyDetails, historyCount, vault, serverTime, refreshOverview) => {
    if (!container) return;
    if (container._vaultTimer) window.clearInterval(container._vaultTimer);
    container._vaultRefreshPending = false;
    const historyWasOpen = Boolean(historyDetails?.open);
    const historyStatuses = new Set(['SHIPPED', 'USED', 'EXPIRED', 'CANCELLED']);
    const activeItems = vault.filter((item) => !historyStatuses.has(item.status));
    const historyItems = vault.filter((item) => historyStatuses.has(item.status));
    const message = container.closest('[data-loyalty-root]')?.querySelector('[data-vault-message]');
    if (message) message.hidden = !activeItems.some((item) => item.physical);
    const labels = { AVAILABLE: 'Beschikbaar', RESERVED: 'Gereserveerd voor bestelling', READY_FOR_FULFILMENT: 'Klaar voor verzending', SHIPPED: 'Verzonden', USED: 'Gebruikt', EXPIRED: 'Verlopen', CANCELLED: 'Geannuleerd' };
    const renderItems = (items) => items.map((item) => {
      const row = el('article', 'vault-item');
      const icon = el('div', 'vault-item__icon', item.physical ? '◈' : '€');
      const body = el('div');
      body.append(el('strong', '', item.name), el('div', 'loyalty-muted', `Aantal: ${item.quantity}`));
      if (item.discount) {
        const discount = el('div', 'vault-discount');
        const benefit = item.discount.kind === 'PERCENTAGE'
          ? `${formatNumber.format(item.discount.value / 100)}% korting`
          : `${new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: item.discount.currency || 'EUR' }).format(item.discount.value / 100)} korting`;
        discount.appendChild(el('strong', 'vault-discount__value', benefit));
        const code = el('code', 'vault-discount__code', item.discount.code);
        discount.appendChild(code);
        if (item.status === 'AVAILABLE') {
          const copy = el('button', 'button button--small button--secondary', 'Code kopiëren');
          copy.type = 'button';
          copy.addEventListener('click', async () => {
            try {
              await navigator.clipboard.writeText(item.discount.code);
              copy.textContent = 'Gekopieerd';
              window.setTimeout(() => { copy.textContent = 'Code kopiëren'; }, 1800);
            } catch {
              window.prompt('Kopieer je kortingscode:', item.discount.code);
            }
          });
          const use = el('a', 'button button--small', 'Gebruik korting');
          use.href = `/discount/${encodeURIComponent(item.discount.code)}?redirect=/cart`;
          discount.append(copy, use);
        }
        body.appendChild(discount);
      }
      if (item.status === 'AVAILABLE' && item.expiresAt) {
        const timer = el('small', 'vault-expiry');
        timer.dataset.vaultDeadline = item.expiresAt;
        timer.setAttribute('role', 'timer');
        body.appendChild(timer);
      }
      if (item.status === 'SHIPPED' && item.shippedAt) body.append(el('small', 'loyalty-muted', `Verzonden op ${item.shippedAt}`));
      if (item.status === 'USED' && item.usedAt) body.append(el('small', 'loyalty-muted', `Gebruikt op ${item.usedAt}`));
      const statusLabel = item.discount && item.status === 'AVAILABLE' ? 'Kortingscode beschikbaar' : labels[item.status] || item.status;
      row.append(icon, body, el('span', `status-pill status-${item.status.toLowerCase()}`, statusLabel));
      return row;
    });
    if (!activeItems.length) {
      const empty = el('div', 'loyalty-empty', vault.length ? 'Je hebt momenteel geen actieve rewards.' : 'Je Reward Vault is nog leeg.');
      empty.style.cssText = 'text-align:left;padding:4px 0';
      container.style.display = 'block';
      container.replaceChildren(empty);
    } else {
      container.style.removeProperty('display');
      container.replaceChildren(...renderItems(activeItems));
    }
    if (historyDetails && historyContainer) {
      historyDetails.hidden = historyItems.length === 0;
      historyDetails.open = historyItems.length > 0 && historyWasOpen;
      historyContainer.replaceChildren(...renderItems(historyItems));
    }
    if (historyCount) historyCount.textContent = String(historyItems.length);
    startVaultTimers(container, serverTime, refreshOverview);
  };

  const renderTransactions = (container, historyContainer, historyDetails, historyCount, transactions) => {
    if (!container) return;
    const historyWasOpen = Boolean(historyDetails?.open);
    const renderRows = (items) => items.map((transaction) => {
      const row = el('div', 'ledger-row');
      const body = el('div');
      body.append(el('strong', '', transaction.description), el('small', 'loyalty-muted', `${transaction.type} · ${transaction.date}`));
      row.append(body, el('strong', transaction.amount >= 0 ? 'ledger-positive' : 'ledger-negative', `${transaction.amount >= 0 ? '+' : ''}${transaction.amount}`));
      return row;
    });
    const recentTransactions = transactions.slice(0, 2);
    const olderTransactions = transactions.slice(2);
    container.replaceChildren(...renderRows(recentTransactions));
    if (historyDetails && historyContainer) {
      historyDetails.hidden = olderTransactions.length === 0;
      historyDetails.open = olderTransactions.length > 0 && historyWasOpen;
      historyContainer.replaceChildren(...renderRows(olderTransactions));
    }
    if (historyCount) historyCount.textContent = String(olderTransactions.length);
  };

  const rarityLabel = (value) => ({ COMMON: 'Common', UNCOMMON: 'Uncommon', RARE: 'Rare', SUPER_RARE: 'Super Rare', SECRET_RARE: 'Secret Rare' }[value] || value);

  const illustrationMaskCache = new Map();
  const buildIllustrationMask = (url) => {
    if (!url) return Promise.reject(new Error('Missing template URL'));
    if (illustrationMaskCache.has(url)) return illustrationMaskCache.get(url);
    const job = (async () => {
      const response = await fetch(url, { mode: 'cors' });
      if (!response.ok) throw new Error('Template mask could not be loaded');
      const bitmap = await createImageBitmap(await response.blob());
      const width = bitmap.width, height = bitmap.height, count = width * height;
      const canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(bitmap, 0, 0); bitmap.close();
      const source = context.getImageData(0, 0, width, height);
      const transparent = new Uint8Array(count), outside = new Uint8Array(count), seen = new Uint8Array(count), queue = new Int32Array(count);
      for (let i = 0; i < count; i += 1) transparent[i] = source.data[i * 4 + 3] < 40 ? 1 : 0;
      let head = 0, tail = 0;
      const addOutside = (index) => { if (index >= 0 && index < count && transparent[index] && !outside[index]) { outside[index] = 1; queue[tail++] = index; } };
      for (let x = 0; x < width; x += 1) { addOutside(x); addOutside((height - 1) * width + x); }
      for (let y = 0; y < height; y += 1) { addOutside(y * width); addOutside(y * width + width - 1); }
      while (head < tail) { const index = queue[head++], x = index % width; if (x > 0) addOutside(index - 1); if (x < width - 1) addOutside(index + 1); if (index >= width) addOutside(index - width); if (index < count - width) addOutside(index + width); }
      let largest = [];
      for (let i = 0; i < count; i += 1) {
        if (!transparent[i] || outside[i] || seen[i]) continue;
        head = 0; tail = 0; seen[i] = 1; queue[tail++] = i; const component = [];
        while (head < tail) {
          const index = queue[head++], x = index % width; component.push(index);
          const visit = (next) => { if (next >= 0 && next < count && transparent[next] && !outside[next] && !seen[next]) { seen[next] = 1; queue[tail++] = next; } };
          if (x > 0) visit(index - 1); if (x < width - 1) visit(index + 1); if (index >= width) visit(index - width); if (index < count - width) visit(index + width);
        }
        if (component.length > largest.length) largest = component;
      }
      if (!largest.length) throw new Error('No enclosed illustration window found');
      let mask = new Uint8Array(count); largest.forEach((index) => { mask[index] = 1; });
      for (let pass = 0; pass < 4; pass += 1) {
        const expanded = mask.slice();
        for (let i = 0; i < count; i += 1) if (mask[i]) { const x = i % width; if (x > 0) expanded[i - 1] = 1; if (x < width - 1) expanded[i + 1] = 1; if (i >= width) expanded[i - width] = 1; if (i < count - width) expanded[i + width] = 1; }
        mask = expanded;
      }
      const output = context.createImageData(width, height);
      for (let i = 0; i < count; i += 1) if (mask[i]) { output.data[i * 4] = 255; output.data[i * 4 + 1] = 255; output.data[i * 4 + 2] = 255; output.data[i * 4 + 3] = 255; }
      context.putImageData(output, 0, 0);
      return canvas.toDataURL('image/png');
    })();
    illustrationMaskCache.set(url, job);
    return job;
  };

  const renderCollection = (root, collection) => {
    const panel = root.querySelector('[data-loyalty-panel="collection"]');
    if (!panel) return;
    const packsNode = panel.querySelector('[data-collection-packs]');
    const shopNode = panel.querySelector('[data-collection-shop]');
    const cardsNode = panel.querySelector('[data-collection-cards]');
    const summaryNode = panel.querySelector('[data-collection-summary]');
    const filter = panel.querySelector('[data-collection-set-filter]');
    const resultNode = panel.querySelector('[data-pack-result]');
    const effectSystem = collection?.effectSystem || {};
    const effectProfiles = new Map((effectSystem.profiles || []).map((profile) => [profile.slug, profile]));
    const cardVisual = (item, alt) => {
      if (item.image_url) {
        const image = el('img'); image.src = item.image_url; image.alt = alt; image.loading = 'lazy'; return image;
      }
      if (item.illustration_url) {
        let data = {};
        try { data = typeof item.card_data === 'string' ? JSON.parse(item.card_data) : (item.card_data || {}); } catch { data = {}; }
        const generated = el('div', `collection-generated-card preview-card family-${String(item.template_family || 'NEUTRAL').toLowerCase()}`);
        const defaults = {art:{x:7,y:14,w:86,h:48},name:{x:8,y:4,w:68,h:6},number:{x:78,y:5,w:15,h:5},family:{x:8,y:64,w:25,h:4},rarity:{x:70,y:64,w:23,h:4},attack:{x:10,y:70,w:25,h:6},health:{x:38,y:70,w:24,h:6},defense:{x:65,y:70,w:25,h:6},role:{x:8,y:77,w:84,h:4},abilityName:{x:8,y:82,w:84,h:4},abilityText:{x:8,y:86,w:84,h:7},flavorText:{x:8,y:94,w:84,h:3}};
        let templateLayout = {}; try { templateLayout = typeof item.template_layout_data === 'string' ? JSON.parse(item.template_layout_data) : (item.template_layout_data || {}); } catch {}
        const layout = Object.keys(templateLayout).length ? templateLayout : defaults;
        const templateUrl = item.template_background_url || '';
        if (templateUrl) { const templateMask=`url("${String(templateUrl).replaceAll('"','%22')}")`;generated.style.setProperty('--foil-frame',templateMask);generated.style.setProperty('--template-mask',templateMask); const bg = el('img', 'collection-generated-card__background'); bg.src = templateUrl; bg.alt = ''; generated.appendChild(bg); }
        const rarityShort={COMMON:'C',UNCOMMON:'UC',RARE:'R',SUPER_RARE:'SR',SECRET_RARE:'SC'};
        const values = {name:item.name,number:item.card_number,family:String(item.template_family||'NEUTRAL'),rarity:rarityShort[item.rarity]||String(item.rarity||''),attack:String(Number(data.attack||0)),defense:String(Number(data.defense||0)),health:String(Number(data.health||0)),role:data.role||'',abilityName:data.abilityName||'',abilityText:data.abilityText||'',flavorText:data.flavorText||''};
        const fontStacks={SYSTEM:'Inter,system-ui,sans-serif',DISPLAY:'Impact,Arial Black,sans-serif',SERIF:'Georgia,serif',MONO:'Consolas,monospace',CONDENSED:'Arial Narrow,Arial,sans-serif',ROUNDED:'Trebuchet MS,Arial,sans-serif'};
        Object.entries(layout).forEach(([key, style]) => { const layer=el('div',`collection-generated-card__layer layer-${key}`),s={...defaults[key],...style};Object.assign(layer.style,{left:`${s.x}%`,top:`${s.y}%`,width:`${s.w}%`,height:`${s.h}%`});if(key==='art'){const art=el('img'),artX=Number(data.artX??50),artY=Number(data.artY??50);art.src=item.illustration_url;art.alt=alt;art.loading='lazy';art.style.objectPosition=`${artX}% ${artY}%`;art.style.transformOrigin=`${artX}% ${artY}%`;art.style.transform=`scale(${Number(data.artScale??100)/100})`;layer.appendChild(art)}else{const vertical={top:'flex-start',center:'center',bottom:'flex-end'}[s.verticalAlign||'top'];layer.textContent=values[key]||'';layer.hidden=Boolean(s.hidden);Object.assign(layer.style,{fontFamily:fontStacks[s.fontFamily]||fontStacks.SYSTEM,fontSize:`${Number(s.fontSize||12)/5.2}cqw`,color:s.color||'#171717',fontWeight:s.fontWeight||700,textAlign:s.align||'left',display:s.hidden?'none':'flex',flexDirection:'column',justifyContent:vertical})}generated.appendChild(layer)});
        const assignedSlug=effectSystem.assignments?.[item.rarity],profile=effectProfiles.get(assignedSlug);
        if(profile?.enabled){
          const effectSeed=Number.parseInt(String(item.card_number||item.id||'1'),10)||Number(item.id||1),scopeCycle=effectSystem.scopeCycle||['ILLUSTRATION','TEMPLATE','BOTH'];
          generated.dataset.effect=String(profile.sourceEffect||profile.slug||'basic');
          generated.dataset.effectScope=String(effectSystem.fixedScopes?.[item.rarity]||scopeCycle[Math.abs(effectSeed-1)%scopeCycle.length]||profile.targetScope||'BOTH');
          Object.entries(profile.attributes||{}).forEach(([key,value])=>{generated.dataset[key]=String(value)});
          Object.entries(profile.variables||{}).forEach(([key,value])=>{if(/^--[a-z0-9-]+$/i.test(key))generated.style.setProperty(key,String(value))});
          generated.style.setProperty('--card-opacity','.78');
          if(templateUrl) generated.dataset.maskTemplateUrl=templateUrl;
          generated.append(el('span','collection-generated-card__shine shine'),el('span','collection-generated-card__glare glare'));
        }
        return generated;
      }
      const placeholder = el('div', 'collection-card__placeholder');
      placeholder.setAttribute('role', 'img');
      placeholder.setAttribute('aria-label', `${alt} · afbeelding volgt`);
      placeholder.append(el('span', '', '◇'), el('small', '', 'Afbeelding volgt'));
      return placeholder;
    };
    if (!collection?.enabled) {
      packsNode.replaceChildren(el('div', 'loyalty-empty', 'De Card Collection is momenteel niet beschikbaar.'));
      shopNode.replaceChildren(); cardsNode.replaceChildren(); summaryNode.replaceChildren();
      return;
    }
    root._collectionData = collection;
    const selectedSet = collection.selectedSet || filter.value || collection.sets[0]?.slug || '';
    filter.replaceChildren(...collection.sets.map((set) => {
      const option = el('option', '', set.name); option.value = set.slug; return option;
    }));
    filter.value = collection.sets.some((set) => set.slug === selectedSet) ? selectedSet : (collection.sets[0]?.slug || '');
    if (!filter.dataset.ready) {
      filter.dataset.ready = 'true';
      filter.addEventListener('change', () => loadCollection(root, filter.value, true));
    }
    const activeSet = filter.value;
    const unopenedPacks = collection.packs.filter((pack) => pack.status === 'UNOPENED' && (!activeSet || pack.set_slug === activeSet));
    setText(panel, '[data-collection-pack-count]', String(unopenedPacks.length));
    const packCard = (pack) => {
      const card = el('article', 'collection-pack-card');
      const media = el('div', 'collection-pack-card__media');
      if (pack.image_url) { const img = el('img'); img.src = pack.image_url; img.alt = pack.image_alt || pack.name; img.loading = 'lazy'; media.appendChild(img); }
      else media.appendChild(el('span', 'collection-pack-card__placeholder', 'PACK'));
      const body = el('div', 'collection-pack-card__body');
      body.append(el('span', 'loyalty-kicker', pack.set_slug), el('h4', '', pack.name), el('small', 'loyalty-muted', `Verkregen via ${String(pack.source_type || '').toLowerCase().replaceAll('_', ' ')}`));
      const open = el('button', 'button', 'Open pack'); open.type = 'button';
      open.addEventListener('click', async () => {
        open.disabled = true; open.textContent = 'Pack openen…';
        try {
          const result = await api.openCollectionPack(pack.id);
          resultNode.hidden = false;
          const title = el('div', 'collection-result__heading');
          title.append(el('span', 'loyalty-kicker', 'Pack geopend'), el('h3', '', `${result.cards.length} kaarten gevonden`));
          const rarityOrder = { COMMON: 1, UNCOMMON: 2, RARE: 3, SUPER_RARE: 4, SECRET_RARE: 5 };
          const orderedCards = [...result.cards].sort((a, b) => (rarityOrder[a.rarity] || 0) - (rarityOrder[b.rarity] || 0) || Number(a.variant === 'FOIL') - Number(b.variant === 'FOIL'));
          const columns = orderedCards.length <= 4 ? Math.max(1, orderedCards.length) : orderedCards.length <= 6 ? 3 : 4;
          const reveal = el('div', 'collection-reveal-stage is-pack-ready'); reveal.style.setProperty('--reveal-columns', String(columns));
          const packIntro = el('div', 'collection-booster-opening');
          const booster = el('button', 'collection-booster'); booster.type = 'button'; booster.setAttribute('aria-label', 'Swipe omhoog om de booster te openen');
          const packFace = el('span', 'collection-booster__face');
          if (pack.image_url) { const packImage = el('img'); packImage.src = pack.image_url; packImage.alt = pack.image_alt || pack.name; packFace.appendChild(packImage); }
          else { packFace.append(el('strong', '', pack.name || 'YTCG BOOSTER'), el('small', '', pack.set_slug || 'COLLECTION PACK')); }
          packFace.classList.add('collection-booster__face--bottom');
          const packTop = packFace.cloneNode(true); packTop.classList.remove('collection-booster__face--bottom'); packTop.classList.add('collection-booster__face--top'); packTop.setAttribute('aria-hidden', 'true');
          booster.append(packFace, packTop, el('span', 'collection-booster__tear'));
          const packInstruction = el('div', 'collection-booster__instruction', 'Swipe omhoog om te openen');
          packIntro.append(booster, packInstruction);
          const stack = el('div', 'collection-reveal-stack'); stack.tabIndex = 0; stack.setAttribute('role', 'button'); stack.setAttribute('aria-label', 'Draai de volgende kaart om');
          const hint = el('button', 'collection-reveal-next', 'Tik op de kaart om hem om te draaien'); hint.type = 'button';
          const grid = el('div', 'collection-reveal-grid');
          const revealCards = orderedCards.map((item, index) => {
            const revealCard = el('article', `collection-card collection-reveal-card is-owned family-${String(item.template_family || 'neutral').toLowerCase()} rarity-${String(item.rarity || 'common').toLowerCase()}${item.variant === 'FOIL' ? ' is-foil' : ''}`);
            const tilt = el('div', 'collection-reveal-card__tilt');
            const flipper = el('div', 'collection-reveal-card__flipper');
            const back = el('div', 'collection-reveal-card__back'); back.append(el('span', '', 'YTCG'), el('small', '', pack.set_slug || 'COLLECTION'));
            const front = el('div', 'collection-reveal-card__front'); front.append(cardVisual(item, item.image_alt || item.name));
            flipper.append(back, front); tilt.appendChild(flipper); revealCard.appendChild(tilt); revealCard.classList.add('is-face-down');
            revealCard.style.setProperty('--stack-index', String(index)); revealCard.style.zIndex = String(orderedCards.length - index);
            return revealCard;
          });
          stack.append(...revealCards);
          let revealed = 0, revealing = false, packOpened = false, pointerStartY = 0;
          const openBooster = () => {
            if (packOpened) return; packOpened = true; booster.classList.add('is-opening'); packInstruction.textContent = 'Booster geopend!';
            window.setTimeout(() => { reveal.classList.remove('is-pack-ready'); reveal.classList.add('is-revealing'); }, 720);
          };
          booster.addEventListener('pointerdown', (event) => { pointerStartY = event.clientY; booster.setPointerCapture?.(event.pointerId); });
          booster.addEventListener('pointerup', (event) => { if (pointerStartY - event.clientY > 35) openBooster(); });
          booster.addEventListener('click', openBooster);
          const revealNext = () => {
            if (!packOpened) { openBooster(); return; }
            if (revealing || revealed >= revealCards.length) return;
            const card = revealCards[revealed];
            if (card.classList.contains('is-face-down')) {
              card.classList.remove('is-face-down'); card.classList.add('is-face-up');
              const burst = el('span', 'collection-card-burst');
              for (let particleIndex = 0; particleIndex < 24; particleIndex += 1) { const particle = el('i'); particle.style.setProperty('--particle-angle', `${particleIndex * 15}deg`); particle.style.setProperty('--particle-distance', `${58 + (particleIndex % 5) * 13}px`); particle.style.setProperty('--particle-delay', `${(particleIndex % 4) * 24}ms`); burst.appendChild(particle); }
              card.appendChild(burst); window.setTimeout(() => burst.remove(), 1100);
              hint.textContent = 'Tik nogmaals voor de volgende kaart'; return;
            }
            revealing = true; card.classList.add('is-dealing');
            window.setTimeout(() => {
              card.classList.remove('is-dealing'); card.classList.add('is-revealed'); card.style.removeProperty('z-index'); card.style.removeProperty('--stack-index'); grid.appendChild(card); revealed += 1; revealing = false;
              if (revealed === revealCards.length) { reveal.classList.add('is-complete'); hint.textContent = 'Alle kaarten onthuld'; stack.removeAttribute('tabindex'); stack.removeAttribute('role'); }
              else hint.textContent = `Tik om kaart ${revealed + 1} om te draaien`;
            }, 280);
          };
          stack.addEventListener('click', revealNext); stack.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); revealNext(); } }); hint.addEventListener('click', revealNext);
          reveal.append(packIntro, stack, hint, grid);
          resultNode.replaceChildren(title, reveal);
          root._collectionData.packs = root._collectionData.packs.filter((item) => item.id !== pack.id);
          result.cards.forEach((openedCard) => {
            const storedCard = root._collectionData.cards.find((item) => Number(item.id) === Number(openedCard.id));
            if (!storedCard) return;
            if (openedCard.variant === 'FOIL') storedCard.foil_quantity = Number(storedCard.foil_quantity || 0) + 1;
            else storedCard.normal_quantity = Number(storedCard.normal_quantity || 0) + 1;
          });
          const activeSet = root._collectionData.sets.find((item) => item.slug === root._collectionData.selectedSet);
          if (activeSet) {
            activeSet.owned_cards = root._collectionData.cards.filter((item) => Number(item.normal_quantity || 0) + Number(item.foil_quantity || 0) > 0).length;
            activeSet.exchangeable_duplicates = root._collectionData.cards.reduce((sum, item) => sum + Math.max(0, Number(item.normal_quantity || 0) - 1) + Math.max(0, Number(item.foil_quantity || 0) - 1), 0);
          }
          renderCollection(root, root._collectionData);
        } catch (error) { window.alert(error.message); open.disabled = false; open.textContent = 'Open pack'; }
      });
      body.appendChild(open); card.append(media, body); return card;
    };
    packsNode.replaceChildren(...(unopenedPacks.length ? unopenedPacks.map(packCard) : [el('div', 'loyalty-empty', 'Je hebt geen ongeopende packs voor deze selectie.') ]));

    const setBySlug = new Map(collection.sets.map((set) => [set.slug, set]));
    const offers = collection.availablePacks.filter((pack) => !activeSet || pack.set_slug === activeSet);
    shopNode.replaceChildren(...(offers.length ? offers.map((pack) => {
      const offer = el('article', 'collection-offer');
      const image = el('div', 'collection-offer__image');
      if (pack.image_url) { const img = el('img'); img.src = pack.image_url; img.alt = pack.image_alt || pack.name; img.loading = 'lazy'; image.appendChild(img); }
      else image.appendChild(el('span', 'collection-pack-card__placeholder', 'PACK'));
      const body = el('div', 'collection-offer__body');
      body.append(el('span', 'loyalty-kicker', pack.set_name), el('h4', '', pack.name));
      if (pack.description) body.append(el('p', 'loyalty-muted', pack.description));
      const actions = el('div', 'collection-offer__actions');
      if (Number(pack.points_cost) > 0) {
        const buy = el('button', 'button', `${formatNumber.format(pack.points_cost)} punten`); buy.type = 'button';
        buy.addEventListener('click', async () => {
          buy.disabled = true;
          try {
            const result = await api.buyCollectionPack(pack.slug);
            if (result.pack && !root._collectionData.packs.some((item) => item.id === result.pack.id)) root._collectionData.packs.unshift(result.pack);
            if (Number.isFinite(Number(result.newBalance))) {
              if (root._overviewData?.wallet) root._overviewData.wallet.balance = Number(result.newBalance);
              document.dispatchEvent(new CustomEvent('loyalty:balance', { detail: Number(result.newBalance) }));
            }
            renderCollection(root, root._collectionData);
          }
          catch (error) { window.alert(error.message); buy.disabled = false; }
        });
        actions.appendChild(buy);
      }
      const set = setBySlug.get(pack.set_slug);
      const duplicates = Number(set?.exchangeable_duplicates || 0);
      const exchange = el('button', 'button button--secondary', `${duplicates}/${pack.duplicate_exchange_cost} duplicaten`); exchange.type = 'button'; exchange.disabled = duplicates < Number(pack.duplicate_exchange_cost);
      exchange.addEventListener('click', async () => {
        exchange.disabled = true;
        try {
          const result = await api.exchangeCollectionDuplicates(pack.slug);
          if (result.pack && !root._collectionData.packs.some((item) => item.id === result.pack.id)) root._collectionData.packs.unshift(result.pack);
          (result.balances || []).forEach((balance) => {
            const card = root._collectionData.cards.find((item) => Number(item.id) === Number(balance.card_id));
            if (!card) return;
            if (balance.variant === 'FOIL') card.foil_quantity = Number(balance.quantity);
            else card.normal_quantity = Number(balance.quantity);
          });
          const changedSet = root._collectionData.sets.find((item) => item.slug === pack.set_slug);
          if (changedSet) changedSet.exchangeable_duplicates = Number(result.remainingDuplicates);
          renderCollection(root, root._collectionData);
        }
        catch (error) { window.alert(error.message); exchange.disabled = duplicates < Number(pack.duplicate_exchange_cost); }
      });
      actions.appendChild(exchange); body.appendChild(actions); offer.append(image, body); return offer;
    }) : [el('div', 'loyalty-empty', 'Er zijn nog geen gepubliceerde packs beschikbaar.') ]));

    const visibleSets = collection.sets.filter((set) => !activeSet || set.slug === activeSet);
    summaryNode.replaceChildren(...visibleSets.map((set) => {
      const item = el('article', 'collection-summary__item');
      item.append(el('strong', '', set.name), el('span', '', `${set.owned_cards}/${set.total_cards} kaarten`), el('small', 'loyalty-muted', `${set.exchangeable_duplicates} inwisselbare duplicaten`));
      return item;
    }));
    const visibleCards = collection.cards.filter((card) => !activeSet || card.set_slug === activeSet);
    cardsNode.replaceChildren(...(visibleCards.length ? visibleCards.map((item) => {
      const owned = Number(item.normal_quantity) + Number(item.foil_quantity) > 0;
      const card = el('article', `collection-card collection-card--visual-only${owned ? ' is-owned' : ' is-locked'}${Number(item.is_foil) ? ' is-foil' : ''}`);
      card.append(cardVisual(item, owned ? (item.image_alt || item.name) : 'Nog niet verzamelde kaart'));
      return card;
    }) : [el('div', 'loyalty-empty', 'Er staan nog geen kaarten in deze set.') ]));
  };

  const loadCollection = async (root, setSlug = '', force = false) => {
    if (root._collectionLoading) return root._collectionLoading;
    if (!force && root._collectionData && (!setSlug || root._collectionData.selectedSet === setSlug)) return root._collectionData;
    const panel = root.querySelector('[data-loyalty-panel="collection"]');
    const cardsNode = panel?.querySelector('[data-collection-cards]');
    if (cardsNode && !root._collectionData) cardsNode.replaceChildren(el('div', 'loyalty-empty', 'Collectie ladenâ€¦'));
    root._collectionLoading = api.getCollection(setSlug).then((collection) => {
      root._collectionData = collection;
      renderCollection(root, collection);
      return collection;
    }).catch((error) => {
      if (cardsNode) cardsNode.replaceChildren(el('div', 'loyalty-empty', error.message));
      throw error;
    }).finally(() => { root._collectionLoading = null; });
    return root._collectionLoading;
  };

  const initOverview = async (root) => {
    try {
      const data = await api.getOverview();
      root._overviewData = data;
      setText(root, '[data-wallet-balance]', formatNumber.format(data.wallet.balance));
      setText(root, '[data-wallet-lifetime]', formatNumber.format(data.wallet.lifetimeEarned));
      setText(root, '[data-wallet-level]', data.wallet.level);
      setText(root, '[data-wallet-next-level]', data.wallet.nextLevel);
      root.querySelectorAll('[data-wallet-progress]').forEach((bar) => { bar.style.width = `${data.wallet.levelProgress}%`; });
      renderGames(root.querySelector('[data-games-list]'), data.games);
      renderQuests(root.querySelector('[data-quests-list]'), data.quests, data.serverTime);
      renderAchievements(
        root.querySelector('[data-achievements-list]'),
        root.querySelector('[data-achievements-history-list]'),
        root.querySelector('[data-achievements-history]'),
        root.querySelector('[data-achievements-history-count]'),
        data.achievements
      );
      renderRewards(root.querySelector('[data-rewards-list]'), data.rewards, data.wallet, () => initOverview(root));
      renderGiveaways(
        root.querySelector('[data-giveaways-section]'),
        root.querySelector('[data-giveaways-list]'),
        root.querySelector('[data-giveaway-history-list]'),
        root.querySelector('[data-giveaway-history]'),
        root.querySelector('[data-giveaway-history-count]'),
        data.giveaways,
        data.wallet,
        data.serverTime,
        () => initOverview(root)
      );
      renderVault(
        root.querySelector('[data-vault-list]'),
        root.querySelector('[data-vault-history-list]'),
        root.querySelector('[data-vault-history]'),
        root.querySelector('[data-vault-history-count]'),
        data.vault,
        data.serverTime,
        () => initOverview(root)
      );
      renderTransactions(
        root.querySelector('[data-transactions-list]'),
        root.querySelector('[data-transactions-history-list]'),
        root.querySelector('[data-transactions-history]'),
        root.querySelector('[data-transactions-history-count]'),
        data.transactions
      );
      root.classList.remove('is-loading');
      if (root._questResetTimer) window.clearTimeout(root._questResetTimer);
      const nextReset = data.quests.map((quest) => quest.resetsAt).filter(Boolean).map(Date.parse).filter((value) => value > Date.parse(data.serverTime)).sort((a, b) => a - b)[0];
      if (nextReset) root._questResetTimer = window.setTimeout(() => initOverview(root), nextReset - Date.parse(data.serverTime) + 1500);
    } catch (error) {
      root.classList.remove('is-loading');
      root.classList.add('has-error');
      const errorNode = root.querySelector('[data-loyalty-error]');
      if (errorNode) { errorNode.hidden = false; errorNode.textContent = error.message; }
    }
  };

  const initCardMatch = (root) => {
    const board = root.querySelector('[data-match-board]');
    const start = root.querySelector('[data-game-start]');
    const status = root.querySelector('[data-game-status]');
    if (!board || !start || !status) return;
    const symbols = ['◆', '★', '●', '▲', '■', '✦'];
    let session;
    let first;
    let lock = false;
    let moves = 0;
    let matches = 0;
    let startedAt = 0;

    const updateStats = () => {
      setText(root, '[data-game-moves]', String(moves));
      setText(root, '[data-game-matches]', `${matches} / ${symbols.length}`);
    };

    const finish = async () => {
      const duration = Date.now() - startedAt;
      const score = Math.max(1000, 12000 - moves * 250 - Math.floor(duration / 100));
      status.textContent = 'Resultaat controleren…';
      try {
        const result = await api.finishGame(session.id, { score, moves, duration });
        status.textContent = config.isAuthenticated
          ? `Voltooid! Score ${formatNumber.format(result.score)} · ${result.pointsAwarded} demo-punten verdiend.`
          : `Voltooid! Score ${formatNumber.format(result.score)}. Log in om bij toekomstige sessies punten te verdienen.`;
        if (result.pointsAwarded) document.dispatchEvent(new CustomEvent('loyalty:balance', { detail: result.newBalance }));
      } catch (error) { status.textContent = error.message; }
      start.hidden = false;
      start.textContent = 'Opnieuw spelen';
    };

    const flip = (button) => {
      if (lock || button.classList.contains('is-flipped') || button.classList.contains('is-matched')) return;
      button.classList.add('is-flipped');
      button.setAttribute('aria-label', `Kaart ${button.dataset.symbol}`);
      if (!first) { first = button; return; }
      moves += 1;
      if (first.dataset.symbol === button.dataset.symbol) {
        first.classList.add('is-matched');
        button.classList.add('is-matched');
        first = null;
        matches += 1;
        updateStats();
        if (matches === symbols.length) finish();
        return;
      }
      lock = true;
      const previous = first;
      first = null;
      window.setTimeout(() => {
        previous.classList.remove('is-flipped');
        button.classList.remove('is-flipped');
        previous.setAttribute('aria-label', 'Gesloten kaart');
        button.setAttribute('aria-label', 'Gesloten kaart');
        lock = false;
      }, 650);
      updateStats();
    };

    start.addEventListener('click', async () => {
      start.disabled = true;
      status.textContent = 'Gamesessie starten…';
      try {
        session = await api.startGame('card-match');
        const cards = [...symbols, ...symbols].sort(() => Math.random() - 0.5);
        board.replaceChildren(...cards.map((symbol, index) => {
          const button = el('button', 'match-card');
          button.type = 'button';
          button.dataset.symbol = symbol;
          button.setAttribute('aria-label', 'Gesloten kaart');
          button.innerHTML = `<span class="match-card__back">?</span><span class="match-card__front" aria-hidden="true">${symbol}</span>`;
          button.addEventListener('click', () => flip(button));
          button.style.setProperty('--card-delay', `${index * 20}ms`);
          return button;
        }));
        first = null; lock = false; moves = 0; matches = 0; startedAt = Date.now();
        updateStats();
        status.textContent = session.rewardEligible ? 'Vind alle paren. Deze demo-sessie kan mockpunten tonen.' : 'Vind alle paren. Gasten verdienen geen punten.';
        start.hidden = true;
      } catch (error) { status.textContent = error.message; }
      start.disabled = false;
    });
  };

  const initCartVault = async (container) => {
    if (!config.isAuthenticated || container.dataset.bound) return;
    container.dataset.bound = 'true';
    try {
      const preview = await api.getCartRewards(Number(container.dataset.cartSubtotal || 0));
      if (!preview.eligibleCount && !preview.waitingCount) return;
      const heading = el('strong', '', preview.eligibleCount ? `${preview.eligibleCount} ${preview.eligibleCount === 1 ? 'reward gaat' : 'rewards gaan'} gratis mee met deze bestelling` : `${preview.waitingCount} ${preview.waitingCount === 1 ? 'reward wacht' : 'rewards wachten'} in je Reward Vault`);
      const message = el('span', '', preview.eligibleCount ? 'Na betaling koppelen we deze automatisch en veilig aan je bestelling.' : `Voeg nog ${new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Math.max(0, Number(preview.nextMinimumCents || 0) - Number(preview.subtotalCents || 0)) / 100)} toe om verzending te ontgrendelen.`);
      const list = el('ul', 'cart-vault-preview__items');
      preview.items.filter((item) => item.eligible).forEach((item) => {
        list.appendChild(el('li', '', `${item.quantity}× ${item.name}`));
      });
      if (preview.eligibleCount && preview.waitingCount) {
        list.appendChild(el('li', 'loyalty-muted', `${preview.waitingCount} ${preview.waitingCount === 1 ? 'andere reward wacht' : 'andere rewards wachten'} op een hogere bestelwaarde.`));
      }
      const link = el('a', '', 'Bekijk Reward Vault →');
      link.href = '/pages/rewards';
      container.replaceChildren(heading, message);
      if (list.childElementCount) container.appendChild(list);
      container.appendChild(link);
      container.hidden = false;
    } catch (error) {
      container.hidden = true;
    }
  };

  const hydrateStandaloneBalances = async () => {
    const nodes = document.querySelectorAll('[data-wallet-balance]');
    if (!nodes.length || !config.isAuthenticated) return;
    try {
      const wallet = await api.getWallet();
      nodes.forEach((node) => { node.textContent = formatNumber.format(wallet.balance); });
    } catch (error) { /* The storefront remains usable when loyalty is unavailable. */ }
  };

  const initPrivacyControls = (root) => {
    const exportButton = root.querySelector('[data-privacy-export]');
    const erasureButton = root.querySelector('[data-privacy-erasure]');
    const statusNode = root.querySelector('[data-privacy-status]');
    if (!exportButton || !erasureButton || !statusNode || exportButton.dataset.bound) return;
    exportButton.dataset.bound = 'true';

    const showStatus = (message, isError = false) => {
      statusNode.textContent = message;
      statusNode.classList.toggle('is-error', isError);
      statusNode.hidden = false;
    };

    exportButton.addEventListener('click', async () => {
      exportButton.disabled = true;
      showStatus('Je gegevensbestand wordt samengesteld…');
      try {
        const data = await api.exportPrivacyData();
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `ytcg-loyalty-export-${new Date().toISOString().slice(0, 10)}.json`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        showStatus('Je loyaltygegevens zijn gedownload als JSON-bestand.');
      } catch (error) {
        showStatus(error.message, true);
      } finally {
        exportButton.disabled = false;
      }
    });

    erasureButton.addEventListener('click', async () => {
      const confirmation = window.prompt('Dit verwijdert of anonimiseert je niet-noodzakelijke loyaltygegevens. Openstaande bestellingen en wettelijke bewaarplichten worden eerst gecontroleerd. Typ VERWIJDER om door te gaan.');
      if (confirmation !== 'VERWIJDER') return;
      erasureButton.disabled = true;
      showStatus('Je verwijderverzoek wordt veilig geregistreerd…');
      try {
        const result = await api.requestPrivacyErasure();
        showStatus(result.message || 'Je verwijderverzoek is ontvangen.');
        erasureButton.textContent = 'Verwijderverzoek ontvangen';
      } catch (error) {
        showStatus(error.message, true);
        erasureButton.disabled = false;
      }
    });
  };

  document.addEventListener('loyalty:balance', (event) => {
    document.querySelectorAll('[data-wallet-balance]').forEach((node) => { node.textContent = formatNumber.format(event.detail); });
  });

  const initLoyaltyTabs = (root) => {
    if (root.dataset.tabsReady === 'true') return;
    const tabs = [...root.querySelectorAll('[data-loyalty-tab]')];
    const panels = [...root.querySelectorAll('[data-loyalty-panel]')];
    if (!tabs.length || !panels.length) return;
    root.dataset.tabsReady = 'true';
    const names = new Set(tabs.map((tab) => tab.dataset.loyaltyTab));
    const hashName = window.location.hash.startsWith('#loyalty-') ? window.location.hash.slice(9) : '';
    const activate = (name, updateHash = true) => {
      const selected = names.has(name) ? name : 'rewards';
      tabs.forEach((tab) => {
        const active = tab.dataset.loyaltyTab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.loyaltyPanel !== selected; });
      if (selected === 'collection') loadCollection(root).catch(() => { /* Error is rendered inside the collection panel. */ });
      if (updateHash) window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#loyalty-${selected}`);
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.loyaltyTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let targetIndex = index;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        tabs[targetIndex].focus();
        activate(tabs[targetIndex].dataset.loyaltyTab);
      });
    });
    activate(hashName || 'rewards', false);
  };

  const tiltSelector = '.collection-reveal-card__tilt,.collection-card,.battle-card';
  if ('IntersectionObserver' in window) {
    const visibilityObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      const card = entry.target;
      const visible = entry.isIntersecting && entry.intersectionRatio >= .01;
      card.classList.toggle('is-card-visible', visible);
      const visual = card.matches('.collection-generated-card') ? card : card.querySelector('.collection-generated-card');
      if (!visual) return;
      visual.classList.toggle('is-effect-visible', visible);
      if (visible && visual.dataset.maskTemplateUrl && !visual.dataset.maskRequested) {
        visual.dataset.maskRequested = 'true';
        buildIllustrationMask(visual.dataset.maskTemplateUrl).then((mask) => {
          visual.style.setProperty('--illustration-mask', `url("${mask}")`);
        }).catch(() => { visual.dataset.maskRequested = ''; });
      }
    }), { rootMargin: '0px', threshold: [0, .01, .15] });
    let idleIndex = 0;
    const idleSelector = '.collection-card-grid .collection-card,.collection-reveal-card__tilt,.battle-card';
    const registerViewportCards = (rootNode) => {
      const cards = [];
      if (rootNode?.matches?.(idleSelector)) cards.push(rootNode);
      rootNode?.querySelectorAll?.(idleSelector).forEach((card) => cards.push(card));
      cards.forEach((card) => {
        if (card.dataset.viewportCardReady) return;
        const index = idleIndex++;
        card.dataset.viewportCardReady = 'true';
        card.dataset.idleMotion = String((index % 4) + 1);
        card.style.setProperty('--card-idle-duration', `${(8.2 + (index % 7) * .47).toFixed(2)}s`);
        card.style.setProperty('--card-idle-delay', `${(-index * 1.31).toFixed(2)}s`);
        visibilityObserver.observe(card);
      });
    };
    registerViewportCards(document);
    new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach(registerViewportCards))).observe(document.body, { childList: true, subtree: true });
  }
  let pendingTiltPoint = null, tiltFrame = 0;
  document.addEventListener('pointermove', (event) => {
    if (event.pointerType === 'touch') return;
    pendingTiltPoint = { x: event.clientX, y: event.clientY };
    if (tiltFrame) return;
    tiltFrame = window.requestAnimationFrame(() => {
      tiltFrame = 0;
      const point = pendingTiltPoint; pendingTiltPoint = null;
      if (!point) return;
      const hit = document.elementFromPoint(point.x, point.y), card = hit?.closest?.(tiltSelector);
      if (!card) return;
      const bounds = card.getBoundingClientRect(), x = (point.x - bounds.left) / bounds.width - .5, y = (point.y - bounds.top) / bounds.height - .5;
      card.style.setProperty('--card-tilt-x', `${(-y * 9).toFixed(2)}deg`); card.style.setProperty('--card-tilt-y', `${(x * 11).toFixed(2)}deg`); card.classList.add('is-card-tilting');
      const foilCard=card.querySelector?.('.collection-generated-card');if(foilCard){const px=(x+.5)*100,py=(y+.5)*100;foilCard.style.setProperty('--pointer-x',`${px}%`);foilCard.style.setProperty('--pointer-y',`${py}%`);foilCard.style.setProperty('--background-x',`${px}%`);foilCard.style.setProperty('--background-y',`${py}%`);foilCard.style.setProperty('--pointer-from-left',String(x+.5));foilCard.style.setProperty('--pointer-from-top',String(y+.5));foilCard.style.setProperty('--pointer-from-center',String(Math.min(1,Math.hypot(x,y)*1.42)));foilCard.style.setProperty('--card-opacity','1')}
    });
  });
  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest?.(tiltSelector); if (!card || card.contains(event.relatedTarget)) return;
    card.style.setProperty('--card-tilt-x', '0deg'); card.style.setProperty('--card-tilt-y', '0deg'); card.classList.remove('is-card-tilting');
    const foilCard=card.querySelector?.('.collection-generated-card');if(foilCard){foilCard.style.setProperty('--pointer-x','50%');foilCard.style.setProperty('--pointer-y','50%');foilCard.style.setProperty('--background-x','50%');foilCard.style.setProperty('--background-y','50%');foilCard.style.setProperty('--card-opacity','.78')}
  });
  document.addEventListener('dragstart', (event) => { if (event.target.closest?.('.collection-card,.collection-generated-card,.battle-card')) event.preventDefault(); });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-loyalty-root]').forEach((root) => { initLoyaltyTabs(root); initOverview(root); initPrivacyControls(root); });
    document.querySelectorAll('[data-loyalty-privacy]').forEach(initPrivacyControls);
    document.querySelectorAll('[data-cart-vault-preview]').forEach(initCartVault);
    hydrateStandaloneBalances();
    if (config.isAuthenticated && config.productId) {
      api.trackProductView(config.productId).catch(() => { /* Product browsing must keep working if loyalty is unavailable. */ });
    }
  });

  document.addEventListener('theme:content-loaded', () => {
    document.querySelectorAll('[data-cart-vault-preview]').forEach(initCartVault);
  });
})();
